/**
 * In this page the [lang] is actually the blog post url
 *
 * e.g. /the-buzz/some-post
 *
 * This is because we have already excluded the index pages in the file `index-lang`
 */

import { getServerSidePropsForIndex } from "lib/get-server-side-props";
export { default } from "pages/[lang]/[post]";

export { getServerSidePropsForIndex as getServerSideProps };

export const config = { amp: "hybrid" };
